/**
 * This function is now deprecated since Fathom has moved to dynamic events.
 * @param goalKey
 */
export default (goalKey: string) => {
    // @ts-ignore
    if (window.fathom) {
        // @ts-ignore
        window.fathom.trackGoal(goalKey, 0)
    } else {
        console.log(`Tracking Fathom goal ${goalKey}`)
    }
}
